import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as SellLogo } from '../../assets/svg/SellWith_horizontal-logo_white.svg';
// import { ReactComponent as SellLogoColored } from '../../assets/svg/SellWith_horizontal-logo.svg';
import { ReactComponent as SellLogoColored } from '../../assets/svg/Scalewith-logo-new.svg';
import { ReactComponent as SellLogoPowered } from '../../assets/svg/SellWith_horizontal-logo-with-tagline_white.svg';
import { ReactComponent as BuyLogo } from '../../assets/svg/BuyWith_horizontal-logo_white.svg';
// import { ReactComponent as BuyLogoColored } from '../../assets/svg/BuyWith_horizontal-logo.svg';
import { ReactComponent as BuyLogoColored } from '../../assets/svg/Buywith-logo-new.svg';
import { ReactComponent as BuyLogoPowered } from '../../assets/svg/BuyWith_horizontal-logo-with-tagline_white.svg';
import { ReactComponent as GiveLogo } from '../../assets/svg/GiveWith_horizontal-logo_white.svg';
import { ReactComponent as GiveLogoPowered } from '../../assets/svg/GiveWith_horizontal-logo-with-tagline_white.svg';
import { ReactComponent as ScaleWithLogo } from '../../assets/svg/Logo_Rectangle.svg';
// import scaleLogoFooter from '../../assets/images/ScaleWith-logo@0.5x.png';
import { ReactComponent as BuywithForSupplier } from '../../assets/svg/BuyWith_for suppliers_white.svg';
// import SioLogo from '../../assets/images/ScaleWith_SIA.png';
import { AccountType } from '../enums';
import { useAccount, useAppSelector } from '../hooks';
import { platform } from '../utils';

interface Props {
  poweredBy?: boolean;
  footer?: boolean;
  coloredLogo?: boolean;
}

const updateFavicon = (newFaviconURL: string) => {
  const link: HTMLLinkElement =
    document.querySelector("link[rel~='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = newFaviconURL;
  document.head.appendChild(link);
  document.title = 'SellWith';
};

const PlatformLogo = (width: string, poweredBy?: boolean, coloredLogo?: boolean) => {
  const platformName = platform();
  const { isAccountInType } = useAccount();
  const instance = useAppSelector((state) => state.app.associatedInstance);
  const isSupplierUser = isAccountInType([AccountType.supplier]);

  useEffect(() => {
    if (isSupplierUser) {
      updateFavicon(
        'https://static.communityimpact.ai/assets/v1/img/jpg/logo-cmtyai-mark-32.9df8f69bd2.jpg',
      );
    }
  }, [isSupplierUser]);

  if (instance) {
    switch (instance.logo) {
      case 'buywith':
        // TODO Replace colored with powered logos
        if (coloredLogo) {
          // return poweredBy ? <BuyLogoPowered width={width} /> : <BuyLogoColored width={width} />;
          // return poweredBy ? <BuyLogoColored width={width} /> : <BuyLogoColored width={width} />;
          return (
            <img
              src="https://static.communityimpact.ai/assets/v1/img/png/logo-buywithfsply-lct-51.ee3a91cf9e.png"
              alt="buywith"
            />
          );
        }
        if (isSupplierUser) {
          // return <BuyLogoColored width={width} />;

          return (
            <img
              src="https://static.communityimpact.ai/assets/v1/img/jpg/selling-lcw-40.9db4f5d681.jpg"
              alt="Selling With Impact"
            />
          );
        }
        // return poweredBy ? <BuyLogoColored width={width} /> : <BuyLogoColored width={width} />;
        // return poweredBy ? <BuyLogoPowered width={width} /> : <BuyLogo width={width} />;
        return (
          <img
            src="https://static.communityimpact.ai/assets/v1/img/jpg/buying-lcw-40.20dfadf8f7.jpg"
            alt="Buying With Impact"
          />
        );

      case 'sellwith':
        if (coloredLogo) {
          // return poweredBy ? <SellLogoPowered width={width} /> : <SellLogoColored width={width} />;
          return (
            <img
              src="https://static.communityimpact.ai/assets/v1/img/jpg/selling-lcw-40.9db4f5d681.jpg"
              alt="Selling With Impact"
            />
          );
        }

        // Later Replace with SellLogo
        // return poweredBy ? <SellLogoPowered width={width} /> : <SellLogoColored width={width} />;
        return (
          <img
            src="https://static.communityimpact.ai/assets/v1/img/jpg/selling-lcw-40.9db4f5d681.jpg"
            alt="Selling With Impact"
          />
        );

      case 'sio':
        return (
          <img
            src="https://static.communityimpact.ai/assets/v1/img/jpg/logo-cmtyai-lcw-40.544113d012.jpg"
            alt="The CommunityAI Logo"
          />
        );

      // return poweredBy ? <SellLogoPowered width={width} /> : <SellLogo width={width} />;

      case 'givewith':
        return poweredBy ? <GiveLogoPowered width={width} /> : <GiveLogo width={width} />;
      case 'scalewith':
        // return <ScaleWithLogo width={width} />;
        return (
          <img
            src="https://static.communityimpact.ai/assets/v1/img/jpg/logo-cmtyai-lcw-40.544113d012.jpg"
            alt="The CommunityAI Logo"
          />
        );
      default:
        // return <SellLogoColored width={width} />;
        return (
          <img
            src="https://static.communityimpact.ai/assets/v1/img/jpg/selling-lcw-40.9db4f5d681.jpg"
            alt="Selling With Impact"
          />
        );
    }
  } else {
    switch (platformName) {
      case 'buy':
        if (coloredLogo) {
          return poweredBy ? <BuyLogoPowered width={width} /> : <BuyLogoColored width={width} />;
        }
        if (isSupplierUser) {
          return <BuywithForSupplier width={width} />;
        }
        return poweredBy ? <BuyLogoPowered width={width} /> : <BuyLogo width={width} />;

      case 'sell':
        if (coloredLogo) {
          return poweredBy ? <SellLogoPowered width={width} /> : <SellLogoColored width={width} />;
        }

        return poweredBy ? <SellLogoPowered width={width} /> : <SellLogo width={width} />;

      case 'give':
        return poweredBy ? <GiveLogoPowered width={width} /> : <GiveLogo width={width} />;
      default:
        return <ScaleWithLogo width={width} />;
    }
  }
};

const Logo: React.FC<Props> = (props) => {
  const { footer, poweredBy, coloredLogo } = props;
  const useOuterContainerWidth = (): [number, React.RefObject<HTMLDivElement>] => {
    const outerContainer = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
      setWidth(outerContainer.current?.offsetWidth || 0);
    }, []);

    return [width, outerContainer];
  };

  const [width, outerContainer] = useOuterContainerWidth();

  return (
    <div
      ref={outerContainer}
      style={{
        width: '100%',
        alignContent: 'center',
        justifyContent: 'center',
        display: 'flex',
      }}
    >
      {' '}
      {footer ? (
        <div
          style={{
            backgroundImage: `url(https://static.communityimpact.ai/assets/v1/img/jpg/logo-cmtyai-lcw-70.4e740ccdf2.jpg)`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            width: `${width}px`,
            height: `${width * (247 / 960)}px`,
          }}
        />
      ) : (
        PlatformLogo(`${width - 30}px`, poweredBy, coloredLogo)
      )}
    </div>
  );
};

export default Logo;
